import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/authsliceAdmin.js";

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});
